import { Flex } from "@chakra-ui/react";
import { StatusReservaEnum } from "core/features/reservas/typings";
import colors from "core/resources/theme/colors";

interface TagStatusProps {
  titulo: string;
  color?: string;
}

export function TagStatus({ titulo, color }: TagStatusProps) {
  return (
    <Flex
      rounded={15}
      border={`solid 1px ${color}`}
      color={color}
      px={2}
      w="fit-content"
      textAlign="center"
    >
      {titulo}
    </Flex>
  );
}

export function TagStatusReserva({
  statusId,
}: {
  statusId: StatusReservaEnum;
}) {
  return statusId === StatusReservaEnum.Confirmada ? (
    <TagStatus titulo="Confirmada" color={colors.green} />
  ) : statusId === StatusReservaEnum.Pendente ? (
    <TagStatus titulo="Pendente" color="orange" />
  ) : statusId === StatusReservaEnum.AguardandoPagamento ? (
    <TagStatus titulo="Aguardando Pagamento" color={colors.yellow} />
  ) : statusId === StatusReservaEnum.Cancelada ? (
    <TagStatus titulo="Cancelada" color="red" />
  ) : null;
}
